import { Box, styled } from '@mui/material';

const StyledNavContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'navWidth',
})<{ navWidth: number }>(({ theme, navWidth }) => ({
  width: navWidth,
  flexGrow: 0,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: 'white',
  userSelect: 'none',
  overflowY: 'auto',
  overflowX: 'clip',
  justifyContent: 'space-between',
  position: 'relative',
  zIndex: 10,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  '&:hover': {
    '&::-webkit-scrollbar': {
      display: 'inline',
    },
    scrollbarWidth: 'thin',
  },
}));

export default StyledNavContainer;
